<template>
  <div class="spm-empty-state">
    <div class="spm-empty-state__icon-wrapper">
      <i :class="['spm-empty-state__icon', icon]" />
    </div>
    <h3 class="spm-empty-state__title">
      {{ title }}
    </h3>
    <p class="spm-empty-state__description">
      {{ description }}
    </p>
    <SpmButton
      :label="buttonLabel"
      :icon="buttonIcon"
      class-style="p-button p-button-primary"
      @click="$emit('action')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';

export default defineComponent({
  name: 'SpmEmptyState',

  components: {
    SpmButton,
  },

  props: {
    icon: {
      type: String,
      required: false,
      default: 'fa-regular fa-folder-open',
    },

    title: {
      type: String,
      required: true,
    },

    description: {
      type: String,
      required: false,
      default: '',
    },

    buttonLabel: {
      type: String,
      required: true,
    },

    buttonIcon: {
      type: String,
      required: false,
      default: 'far fa-plus-circle',
    },
  },

  emits: ['action'],
});
</script>

<style lang="scss" scoped>
.spm-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  text-align: center;
}

.spm-empty-state__icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: var(--surface-100, #f3f4f6);
  margin-bottom: 1.25rem;
}

.spm-empty-state__icon {
  font-size: 1.75rem;
  color: var(--text-color-secondary, #9ca3af);
}

.spm-empty-state__title {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-color, #1f2937);
  margin: 0 0 0.5rem 0;
}

.spm-empty-state__description {
  font-size: 0.875rem;
  color: var(--text-color-secondary, #6b7280);
  margin: 0 0 1.5rem 0;
  max-width: 400px;
  line-height: 1.5;
}
</style>
